<template>
	<div>
		<v-overlay :value="value" :key="0">
			<Dialog v-bind:value="value" @input="$emit('input', $event)"
							:title="title" :stickyFooter="true" @click:outside="close" :persistent="true"
							replace-buttons fullscreen @cancel="close"
							transition="dialog-bottom-transition" :scrollable="true"
			>
				<v-row no-gutters>
					<v-col>
						<div class="d-flex align-center justify-space-between mb-3" style="max-width:100%;">
							<div class="d-flex flex-row align-center"
									 :style="{width: selectedEntry === null ? '82%' : '88%'}">
								<v-chip class="mr-3 font-weight-bold" dark label small v-if="selectedEntry"
												:color="accentColor">
									{{ type.toUpperCase() }}
								</v-chip>
							</div>
							<div class="d-flex flex-row align-center">
								<v-chip class="mr-2 d-flex justify-end font-weight-bold" dark label small
												:color="ada.blue" @click="showTemplateDialog = true"
												v-if="selectedEntry === null">
									load template
								</v-chip>
								<v-chip class="mr-2 d-flex justify-end font-weight-bold" dark label small
												:color="ada.purple" @click="prettify">
									prettify
								</v-chip>
								<v-chip class="mr-2 d-flex justify-end font-weight-bold" dark label small
												:color="ada.darkGrey" @click="uglify">
									uglify
								</v-chip>
								<TooltipIcon tooltip="JSONs vergleichenn" :color="ada.purple" fab xsmall
														 @click="$emit('click:json-compare')"
								>
									mdi-file-compare
								</TooltipIcon>
							</div>
						</div>
					</v-col>
				</v-row>

				<!-- TEXT EDITOR -->
				<v-row no-gutters>
					<v-col cols="12">
						<AceEditor
							v-model="mainJSON"
							@init="initEditor"
							lang="html"
							theme="chrome"
							width="100%"
							height="500"
							:options="aceConfig"
						/>
					</v-col>
					<v-col>
						<v-alert dense :value="checkDuplicateKeys.length !== 0" type="warning" width="100%"
										 class="mt-2 mb-0">
							Für folgende Identifier existiert bereits ein Template: <b>{{
								checkDuplicateKeys.join(', ')
							}}</b>
						</v-alert>
						<v-alert dense :value="!ignoreMissingPlaceholders && missingPlaceholders.length !== 0"
										 type="error" width="100%" class="mt-2 mb-0 placeholderAlert">
							<div class=" d-flex flex-wrap justify-space-between align-center">
								<div>Folgende Platzhalter fehlen: {{ missingPlaceholders.join(', ') }}</div>
								<Button class="ml-4" text @click="ignoreMissingPlaceholders = true">Ignorieren
								</Button>
							</div>
						</v-alert>
					</v-col>
				</v-row>
				<v-row no-gutters>


					<!-- SEITENTYP -->
					<v-col cols="2">
						<v-radio-group class="typeTitle"
													 dense column label="Seitentyp"
													 v-model="selectedType"
													 :disabled="$store.state.readOnly === 1"
						>
							<v-radio
								v-for="(type, i) in types" :key="'type_'+i"
								:label="type.name"
								:color="accentColor"
								:value="type.value"
							></v-radio>
						</v-radio-group>
					</v-col>


					<!-- POSITIONEN -->
					<v-col cols="8">
						<v-row no-gutters>
							<v-col>
								<Dropdown v-model="selectedPositions" style="position:relative; top:20px;"
													label="Positionen" class="mr-8" :loading="loadingPositions"
													:items="allPositions"
													:disabled="$store.state.readOnly === 1"
													:multiple="true"></Dropdown>
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<div class="d-flex flex-row align-center notFoundPositionsContainer mr-8">
									<div class="mr-4 d-flex flex-row align-center">
										<Input class="mr-2" style="min-width:150px; max-width: 150px" label="Neue
                                    Position" @enter="addPosition"
													 :disabled="$store.state.readOnly === 1"
													 v-model="newPosition" hide-details></Input>
										<TooltipIcon style="position:relative; top:-10px"
																 :disabled="$store.state.readOnly === 1"
																 tooltip="Position hinzufügen"
																 fab xsmall :color="accentColor" @click="addPosition">mdi-plus
										</TooltipIcon>
									</div>
									<div>
										<v-chip v-for="(pos,i) in notFoundPositions" :key="'notFoundPos'+i"
														label :color="ada.lightGrey" :close="$store.state.readOnly !== 1"
														@click:close="removePosition(pos)"
														class="mb-2"
														:class="{'mr-2': i+1 !== notFoundPositions.length}">
											{{ pos }}
										</v-chip>
									</div>
								</div>
							</v-col>
						</v-row>
					</v-col>


					<!-- TEASERTYPES -->
					<v-col cols="2">
						<!--<div class="text-body-1" style="position:relative; top:15px">Teasertyp</div>-->
						<div class="teasertypesContainer d-flex flex-column">
							<div>
								<v-radio-group class="typeTitle"
															 dense column label="TeaserTyp"
															 v-model="selectedMainTeasertype"
															 :disabled="$store.state.readOnly === 1"
								>
									<v-radio
										v-for="(type, i) in vuexState.teasertypes.filter(x => x.name === 'Anzeige' || x.name === 'Presenter')"
										:key="'maintype_'+i"
										:label="type.name"
										:color="accentColor"
										:value="type.value"
									></v-radio>
								</v-radio-group>
							</div>
							<div class="teasertype_cbx">
								<v-checkbox
									v-model="selectedTeasertypes"
									v-for="(teasertype, i) in vuexState.teasertypes.filter(x => x.name !== 'Anzeige' && x.name !== 'Presenter')"
									:key="'teasertype_'+i"
									:color="accentColor"
									multiple
									hide-details
									:disabled="$store.state.readOnly === 1"
									:label="teasertype.name"
									:value="teasertype"
								></v-checkbox>
							</div>
						</div>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<div class="text-body-1 d-flex align-center mb-2" style="cursor: pointer; width: 11rem;"
								 @click="toggleOutput">JSON Output
							<v-icon class="pl-1">
								{{ showJsonOutput ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
							</v-icon>
						</div>
						<v-expand-transition>
							<AceEditor
								v-show="showJsonOutput"
								v-model="jsonOutput"
								@init="initEditor"
								lang="json"
								theme="chrome"
								width="100%"
								height="200"
								ref="jsonOutputEditor"
								:options="aceConfigReadOnly"
							/>
						</v-expand-transition>
					</v-col>
				</v-row>
				<template #button>
					<Button :text="true" :color="ada.pink" @click="submit('live')"
									:disabled="!ignoreMissingPlaceholders && missingPlaceholders.length !== 0 || checkDuplicateKeys.length !== 0 || $store.state.readOnly === 1">
						Deploy:Live
					</Button>
					<Button :text="true" :color="ada.blue" @click="submit('stage')"
									:disabled="!ignoreMissingPlaceholders && missingPlaceholders.length !== 0 || checkDuplicateKeys.length !== 0 || $store.state.readOnly === 1">
						Deploy:Stage
					</Button>
					<Button :text="true" :color="ada.darkGrey" @click="submit('copy')"
									:disabled="!ignoreMissingPlaceholders && missingPlaceholders.length !== 0 || checkDuplicateKeys.length !== 0 || $store.state.readOnly === 1">
						Template Kopieren
					</Button>
					<v-spacer></v-spacer>
					<Button v-if="selectedEntry" :text="true" :color="ada.red" icon="mdi-delete"
									:disabled="$store.state.readOnly === 1"
									@click="$emit('click:delete', 'stage', getFinalJson(true))">
						Stage löschen
					</Button>
					<Button v-if="selectedEntry" :text="true" :color="ada.red" icon="mdi-delete"
									:disabled="$store.state.readOnly === 1"
									@click="$emit('click:delete', 'live', getFinalJson(true))">
						Live löschen
					</Button>
				</template>
			</Dialog>
		</v-overlay>
		<JsonLoadTemplateDialog v-model="showTemplateDialog" @click:row="loadTemplate"
														:type="type"></JsonLoadTemplateDialog>
		<SaveChangesDialog v-model="showSaveChangesDialog" @discard="close(true)"
											 @save="submit(type)" :hide-cancel="false"
											 @cancel="showSaveChangesDialog = false"
		></SaveChangesDialog>
	</div>
</template>

<script>
import Dialog from "../../components/Dialog"
import Button from "../../components/buttons/Button";
import ada from "../../scss/ada_colors.scss";
import AceEditor from 'vuejs-ace-editor';
import Utils from "../../scripts/Utils";
import Dropdown from "../../components/Inputs/Dropdown";
import Input from "../../components/Inputs/Input";
import TooltipIcon from "../../components/TooltipIcon";
import JsonLoadTemplateDialog from "./JsonLoadTemplateDialog";
import SaveChangesDialog from "../components/SaveChangesDialog";

export default {
	name: "JsonEditDialog",
	components: {SaveChangesDialog, JsonLoadTemplateDialog, TooltipIcon, Input, Dropdown, Button, Dialog, AceEditor},
	props: ['value', 'type', 'sitetype', 'submitDone'],
	data: () => {
		return {
			ada,
			showTemplateDialog: false,
			showJsonOutput: false,
			showSaveChangesDialog: false,
			beautifier: null,
			mainJSON: "",
			jsonOutput: '{}',
			selectedType: null,
			newPosition: null,
			selectedPositions: [],
			selectedTeasertypes: [],
			selectedMainTeasertype: null,
			allPositions: [],
			notFoundPositions: [],
			loadingPositions: false,
			newTemplateEntry: null,
			placeholders: ['text1', 'headline1', 'imageUrl', 'clickUrl'],
			missingPlaceholders: [],
			ignoreMissingPlaceholders: false,
		}
	},
	mounted() {
		this.init();
		if (this.siteDetails && this.allPositions.length === 0) {
			this.fetchPositions();
		}
	},
	computed: { ///api/service.php/management/getZoneDetails?zone_id=' + zoneId
		vuexState() {
			return this.$store.state.editor;
		},
		selectedEntry() {
			return this.vuexState.selectedEntry;
		},
		siteDetails() {
			return this.vuexState.siteDetails;
		},
		title() {
			let ret = 'Template ';
			if (this.selectedEntry) {
				ret += 'bearbeiten - ' + (this.vuexState.selectedSite ? this.vuexState.selectedSite.Name : '');
				ret += ': ' + (this.sitetype ? `${this.sitetype.Name} - ${this.sitetype.SitetypeId}.json` : '');
			} else {
				ret += 'hinzufügen';
			}
			return ret;
		},
		entry() {
			return this.vuexState['jsonContent_' + this.type] ? this.vuexState['jsonContent_' + this.type][this.selectedEntry.completeKey] : null;
		},
		aceConfig() {
			let ret = JSON.parse(JSON.stringify(this.$store.state.aceConfig));
			ret.readOnly = this.$store.state.readOnly;
			return ret;
		},
		aceConfigReadOnly() {
			let ret = JSON.parse(JSON.stringify(this.$store.state.aceConfig));
			ret.readOnly = true;
			return ret;
		},
		types() {
			return this.vuexState.types;
		},
		accentColor() {
			return this.type === 'live' ? ada.pink : ada.blue;
		},
		uglifiedJSON() {
			return Utils.uglifyHTML(this.mainJSON);
		},
		combinedPositions() {
			let positions = this.selectedPositions.map(x => x.value).concat(this.notFoundPositions);
			return positions.sort(Utils.naturalCompare);
		},
		jsonOutputKey() {
			let keys = [];
			let positions = this.combinedPositions;
			let type = this.selectedType === 'default' ? '' : '_' + this.selectedType;
			let main_teasertype = this.selectedMainTeasertype === '_Presenter' ? '' : this.selectedMainTeasertype;
			let teasertypes = [];

			//to guarantee the correct teasertype order
			let teasertypesArr = this.vuexState.teasertypes.filter(x => x.name !== 'Anzeige' && x.name !== 'Presenter');
			for (let i = 0; i < teasertypesArr.length; i++) {
				if (this.selectedTeasertypes.find(x => x.name === teasertypesArr[i].name)) {
					teasertypes.push(teasertypesArr[i].value);
				}
			}

			positions.forEach((position) => {
				keys.push(position + type + main_teasertype + teasertypes.join(''));
			})
			return keys.join(', ');
		},
		checkDuplicateKeys() {
			return Utils.checkDuplicateKeys(this.getFinalJsonKey(), this.vuexState['jsonContent_' + this.type], this.selectedEntry ? this.selectedEntry.completeKey : null);
		},
	},
	methods: {
		async init(loadTemplate = false) {
			//onsole.log(Utils.prettifyHTML(this.entry));
			// eslint-disable-next-line no-undef
			//this.mainJSON = html_beautify(this.entry);
			this.selectedPositions = []
			this.ignoreMissingPlaceholders = false;
			if (!loadTemplate) this.newTemplateEntry = null;
			if (this.selectedEntry || this.newTemplateEntry) {
				this.mainJSON = Utils.prettifyHTML(loadTemplate && this.newTemplateEntry ? this.newTemplateEntry.html : this.entry);
				// eslint-disable-next-line no-undef
				//this.mainJSON = html_beautify(this.entry);
				let entry = loadTemplate ? this.newTemplateEntry : this.selectedEntry;
				this.selectedMainTeasertype = entry.teasertypes.includes('Anzeige') ? '_Anzeige' : '_Presenter';
				this.selectedType = entry.type.value;
				this.initPositions(loadTemplate);
				this.initTeasertypes(loadTemplate);
			} else {
				this.mainJSON = "";
				this.selectedTeasertypes = [];
				this.notFoundPositions = [];
				this.selectedType = 'default'
				this.selectedMainTeasertype = '_Presenter';
				this.$store.commit('editor/setFinalTemplateKey', null);
				this.$store.commit('editor/setFinalJson', null);
			}
			this.updateJSONOutput();
		},
		async fetchPositions() {
			let ret = [];
			this.loadingPositions = true;
			let data = await this.$store.dispatch('zones/fetchZoneDetails', this.vuexState.siteDetails.Zones[0].ZoneId);
			this.loadingPositions = false;
			Object.keys(data.Position).forEach((position) => {
				ret.push({
					text: position,
					value: position
				})
			});
			if (ret.length !== 0) ret.sort(Utils.naturalCompare);
			this.allPositions = ret;
		},
		initPositions(loadFromTemplate) {
			this.notFoundPositions = [];
			let template = loadFromTemplate ? this.newTemplateEntry : this.selectedEntry;
			if (this.allPositions && this.allPositions.length !== 0 && template) {
				for (let i = 0; i < template.positions.length; i++) {
					let position = this.allPositions.find(x => x.value === template.positions[i]);
					if (position) {
						this.selectedPositions.push(position);
					} else {
						this.notFoundPositions.push(template.positions[i])
					}
				}
			}
		},
		initTeasertypes(loadFromTemplate) {
			let template = loadFromTemplate ? this.newTemplateEntry : this.selectedEntry;
			if (template) {
				this.selectedTeasertypes = [];
				template.teasertypes.forEach((teasertype) => {
					this.selectedTeasertypes.push(this.vuexState.teasertypes.find(x => x.name === teasertype));
				})
			}
		},
		initEditor() {
			require('brace/ext/searchbox'); //language extension prerequsite...
			require('brace/ext/language_tools'); //language extension prerequsite...
			require('brace/mode/html');    //language
			require('brace/snippets/html')
			require('brace/mode/json');    //language
			require('brace/snippets/json')
			require('brace/theme/chrome');
		},
		submit(type) {
			this.$store.commit('editor/setFinalTemplateKey', this.getFinalJsonKey());
			this.$store.commit('editor/setFinalJson', this.getFinalJson());
			this.$emit('submit', type, this.getFinalJson());
			this.$emit('selectedData', {selectedType: this.selectedType, selectedTeasertypes: this.selectedTeasertypes});
		},
		removePosition(pos) {
			this.notFoundPositions.splice(this.notFoundPositions.findIndex(x => x === pos), 1);
		},
		addPosition() {
			if (this.allPositions.find(x => x.value === this.newPosition)) {
				this.$root.$emit('snackbar', 'Diese Position existiert bereits im obigen Dropdown. Bitte dort auswählen.', 'warning')
			} else {
				this.notFoundPositions.push(this.newPosition);
				this.newPosition = null;
			}
		},
		getFinalJson(deleting = false) {
			let json = JSON.parse(JSON.stringify(this.vuexState['jsonContent_' + this.type]));
			if (deleting) {
				delete json[this.getFinalJsonKey()];
			} else {
				if (this.selectedEntry && this.selectedEntry.completeKey !== this.getFinalJsonKey()) delete json[this.selectedEntry.completeKey];
				this.prettify();
				json[this.getFinalJsonKey()] = Utils.uglifyHTML(this.mainJSON);
			}
			return json;
		},
		getFinalJsonKey() {
			// check if key already exists (ignoring the order) if yes return the key
			return Utils.getFinalJsonKey(this.jsonOutputKey, this.vuexState['jsonContent_' + this.type]);
		},
		updateJSONOutput() {
			let currentJSONOutputKey = Object.keys(JSON.parse(this.jsonOutput))[0];
			if ((this.selectedEntry && (currentJSONOutputKey !== this.jsonOutputKey)) || this.uglifiedJSON !== JSON.parse(this.jsonOutput)[currentJSONOutputKey] ||
				(this.selectedEntry === null && (currentJSONOutputKey !== this.getFinalJsonKey()))
			) {
				let ret = {};
				let keys = [];
				let positions = this.selectedPositions.map(x => x.value).concat(this.notFoundPositions);
				positions.sort(Utils.naturalCompare);
				let type = this.selectedType === 'default' ? '' : '_' + this.selectedType;
				let teasertypes = [];

				//to guarantee the correct order
				for (let i = 0; i < this.vuexState.teasertypes.length; i++) {
					if (this.selectedTeasertypes.find(x => x.name === this.vuexState.teasertypes[i].name)) {
						teasertypes.push(this.vuexState.teasertypes[i].value);
					}
				}

				positions.forEach((position) => {
					keys.push(position + type + teasertypes.join(''));
				})
				ret[this.jsonOutputKey] = this.uglifiedJSON;
				this.jsonOutput = JSON.stringify(ret, null, 1);
			}
		},
		loadTemplate(entry) {
			this.newTemplateEntry = entry;
			this.init(true);
			this.showTemplateDialog = false;
		},
		hasChanges() {
			if (this.selectedEntry) {
				return this.selectedEntry.completeKey !== this.getFinalJsonKey() ||
					Utils.uglifyHTML(Utils.prettifyHTML(this.uglifiedJSON)) !== Utils.uglifyHTML(Utils.prettifyHTML(this.vuexState['jsonContent_' + this.type][this.selectedEntry.completeKey]));
			} else {
				return this.uglifiedJSON !== '' || this.getFinalJsonKey() !== '';
			}
		},
		toggleOutput() {
			this.showJsonOutput = !this.showJsonOutput;
			setTimeout(() => {
				if (this.showJsonOutput) {
					var objDiv = document.querySelector(".v-dialog__content--active .v-card__text");
					objDiv.scrollTo({top: objDiv.scrollHeight, behavior: 'smooth'});
				}
			}, 350)
		},
		prettify() {
			this.mainJSON = Utils.prettifyHTML(this.mainJSON);
		},
		uglify() {
			this.mainJSON = this.uglifiedJSON;
		},
		close(discardChanges = false) {
			if (this.hasChanges() && !discardChanges && this.$store.state.readOnly === 0) {
				this.showSaveChangesDialog = true;
			} else {
				this.newTemplateEntry = null;
				this.$store.commit('editor/setSelectedEntry', null);
				this.$emit('input', false);
				if (this.selectedEntry === null) this.init();
			}
		},
		updateSelectedEntry() {
			this.$store.commit('editor/setSelectedEntry', {
				completeKey: this.getFinalJsonKey(),
				positions: this.combinedPositions,
				teasertypes: this.selectedTeasertypes.map(x => x.name),
				type: this.$store.state.editor.types.find(x => x.value === this.selectedType)
			});
		}
	},
	watch: {
		selectedEntry() {
			this.init();
		},
		siteDetails() {
			if (this.siteDetails) {
				this.fetchPositions();
			}
		},
		allPositions() {
			this.initPositions();
		},
		selectedMainTeasertype() {
			this.updateJSONOutput();
		},
		selectedTeasertypes() {
			this.updateJSONOutput();
		},
		uglifiedJSON(json) {
			this.updateJSONOutput();

			let ret = [];
			this.placeholders.forEach((placeholder) => {
				if (json.indexOf('[' + placeholder + ']') === -1) {
					ret.push('[' + placeholder + ']');
				}
			})
			this.missingPlaceholders = ret;
		},
		selectedType() {
			this.updateJSONOutput();
		},
		selectedPositions() {
			this.updateJSONOutput();
		},
		notFoundPositions() {
			this.updateJSONOutput();
		},
		submitDone() {
			this.updateSelectedEntry();
			if (this.showSaveChangesDialog) {
				this.showSaveChangesDialog = false;
				this.close();
			}
		},
	}
}
</script>

<style lang="scss" scoped>
.mainJsonTitle {
	width: 100%;
	/*
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;*/
	flex: 1;
}

.teasertype_cbx {
	display: flex;
	flex-flow: column;
	margin-top: 4.8rem;

	::v-deep .v-input--selection-controls {
		margin-top: 8px;
	}
}

::v-deep .v-input--radio-group__input legend {
	font-size: 1rem !important;
	font-weight: 400;
}

.notFoundPositionsContainer ::v-deep .mdi-close-circle::before {
	color: #a6afb5;
}

.teasertypesContainer > div {
	height: 25px;
}

::v-deep .placeholderAlert i {
	top: 5px;
}
</style>